import { typeWireOf } from "@typewirets/core";
import {
  JsonLocalStorage,
  PrefixedSyncJsonStorage,
  type SyncJsonStorage,
} from "./sync-json-storage";

export const JsonSyncStorageWire = typeWireOf({
  token: "JsonSyncStorage",
  createWith(): SyncJsonStorage {
    return new JsonLocalStorage();
  },
});

export const PrefixedStorageLoaderWire = typeWireOf({
  token: "PrefixedStorageLoader",
  imports: {
    jsonStorage: JsonSyncStorageWire,
  },
  createWith({ jsonStorage }) {
    return {
      load(prefix: string): SyncJsonStorage {
        return new PrefixedSyncJsonStorage(prefix, jsonStorage);
      },
    };
  },
});
